import { Store } from 'src/store';
import isDesignHasEmptyContent from 'src/util/design/isDesignHasEmptyContent';

// eslint-disable-next-line max-len
const shouldDisplayEmptyDesignWarning = (store: Store) => store.design.structure && isDesignHasEmptyContent(store.design.structure);

export default shouldDisplayEmptyDesignWarning;
